import { AppState } from 'store/store';

export const officialDetailsSelector = (state: AppState) => state.officials.details;
